import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { RaBreadcrumb } from "../components/RaBreadcrumb";
import { RaExplainer } from "../components/RaExplainer";
import { ReadabilityTool } from "../components/ReadabilityTool";

export function ReadabilityPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <RaBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.ra_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.ra_intro()}
          </p>
        </header>

        <ReadabilityTool />

        <RaExplainer
          howTo={m.ra_howto()}
          faqs={[
            { q: m.ra_faq1_q(), a: m.ra_faq1_a() },
            { q: m.ra_faq2_q(), a: m.ra_faq2_a() },
            { q: m.ra_faq3_q(), a: m.ra_faq3_a() },
            { q: m.ra_faq4_q(), a: m.ra_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
